import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers/rootReducer'

import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import requestMiddleware from 'stateManagement/middlewares/requestMiddleware';

const persistConfig = {
  key: 'root',
  storage,
  // blacklist: ['navigation'], // navigation will not be persisted
  // whitelist: ['navigation'] // only navigation will be persisted
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
export const store = createStore(
  persistedReducer,
  //  applyMiddleware(createLogger(), requestMiddleware()),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
export const persistor = persistStore(store);

// const store = createStore(
//     rootReducer,
//     // applyMiddleware(createLogger()),
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
//   );

//   export default store;